import React from 'react';
import { FadeIn } from './FadeIn';
export function WhoIsItFor() {
  const forWho = ['Hombres y mujeres de 40 a 65 años que se sienten estancados.', "Personas que sufren de fatiga crónica y 'niebla mental'.", 'Quienes han intentado todas las dietas y siempre recuperan el peso.', 'Profesionales con poco tiempo que necesitan resultados sin vivir en el gimnasio.'];
  const notForWho = ["Personas que buscan una 'pastilla mágica' de la noche a la mañana.", 'Atletas de alto rendimiento que ya tienen un metabolismo optimizado.', 'Quienes no están dispuestos a cambiar 30 segundos de su ducha diaria.'];
  return <section className="py-20 bg-white" data-id="element-239">
      <div className="container px-4 mx-auto max-w-5xl" data-id="element-240">
        <div className="grid gap-12 md:grid-cols-2" data-id="element-241">
          {/* Para quién es */}
          <FadeIn direction="right" data-id="element-242">
            <div className="h-full p-8 bg-emerald-50/50 rounded-3xl border border-emerald-100" data-id="element-243">
              <h3 className="mb-6 text-2xl font-bold text-gray-900 flex items-center gap-3" data-id="element-244">
                <span className="flex items-center justify-center w-10 h-10 bg-emerald-100 text-emerald-600 rounded-full" data-id="element-245">
                  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-246">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-247" />
                  </svg>
                </span>
                Para quién SÍ es
              </h3>
              <ul className="space-y-4" data-id="element-248">
                {forWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-249">
                    <span className="text-emerald-500 mr-3 mt-1 text-xl" data-id="element-250">
                      •
                    </span>
                    <span className="text-lg text-gray-700" data-id="element-251">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>

          {/* Para quién NO es */}
          <FadeIn direction="left" delay={0.2} data-id="element-252">
            <div className="h-full p-8 bg-red-50/50 rounded-3xl border border-red-100" data-id="element-253">
              <h3 className="mb-6 text-2xl font-bold text-gray-900 flex items-center gap-3" data-id="element-254">
                <span className="flex items-center justify-center w-10 h-10 bg-red-100 text-red-600 rounded-full" data-id="element-255">
                  <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-256">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" data-id="element-257" />
                  </svg>
                </span>
                Para quién NO es
              </h3>
              <ul className="space-y-4" data-id="element-258">
                {notForWho.map((item, index) => <li key={index} className="flex items-start" data-id="element-259">
                    <span className="text-red-500 mr-3 mt-1 text-xl" data-id="element-260">•</span>
                    <span className="text-lg text-gray-700" data-id="element-261">{item}</span>
                  </li>)}
              </ul>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}